var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.544,
    height: 18.052,
    viewBox: "0 0 19.544 18.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "showcase",
    transform: "matrix(0.914, -0.407, 0.407, 0.914, -3386.563, -2829.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2666",
    "data-name": "Group 2666",
    transform: "translate(1940.833 3967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4283",
    "data-name": "Path 4283",
    d: "M124.434,100.353h-.083l.014-3.962a.473.473,0,1,0-.945,0v.4l-8.231,3.225h-.931a.95.95,0,0,0-.932.932v2.628a.929.929,0,0,0,.639.879v4.181a1.015,1.015,0,0,0,2.029,0V104.8l7.4,2.918v.4a.473.473,0,0,0,.945,0l.014-3.976h.083a.858.858,0,0,0,.848-.834V101.2a.86.86,0,0,0-.848-.848Z",
    transform: "translate(-113.325 -95.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4284",
    "data-name": "Path 4284",
    d: "M463.14,130.254l-.249-.337-3.212,2.434.264.323Z",
    transform: "translate(-446.758 -128.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4285",
    "data-name": "Path 4285",
    d: "M479.419,216.953l3.916-.924-.088-.411-3.916.924Z",
    transform: "translate(-465.677 -211.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4286",
    "data-name": "Path 4286",
    d: "M481.32,289.1l-3.96-.7.073-.41,3.96.7Z",
    transform: "translate(-463.78 -280.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4287",
    "data-name": "Path 4287",
    d: "M455.35,330.8l3.388,2.141.235-.352-3.4-2.156Z",
    transform: "translate(-442.591 -321.687)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcase);
export default __webpack_public_path__ + "static/media/showcase.da0596b2c0f58e4fb3656fce7ab590c7.svg";
export { ForwardRef as ReactComponent };